import { useTranslation } from 'react-i18next';

export default function HowItWorks() {
  const { t } = useTranslation();

  const liveStreams = [
    {
      id: 1,
      church: 'Ikeja Central SDA Church',
      location: 'Lagos State, Southwest Region',
      conference: 'Lagos Conference',
      badge: 'Official',
      viewers: 1247,
      thumbnail: 'https://public.readdy.ai/ai/img_res/dc763dc0ad0137d03737de1262b2a59b.jpg'
    },
    {
      id: 2,
      church: 'Abuja Central SDA Church',
      location: 'FCT, North-Central Region',
      conference: 'Abuja Conference',
      badge: 'Official',
      viewers: 892,
      thumbnail: 'https://readdy.ai/api/search-image?query=vibrant%20church%20worship%20service%20with%20colorful%20stage%20lighting%20and%20praise%20team%20performing%20contemporary%20christian%20music%20worship%20band%20on%20stage&width=800&height=600&seq=abuja-central-live&orientation=landscape'
    },
    {
      id: 3,
      church: 'Port Harcourt District Church',
      location: 'Rivers State, South-South Region',
      conference: 'Rivers Conference',
      badge: 'Conference-Recognized',
      viewers: 654,
      thumbnail: 'https://readdy.ai/api/search-image?query=church%20choir%20singing%20in%20black%20robes%20during%20worship%20service%20traditional%20church%20choir%20performance%20with%20hymn%20books%20beautiful%20harmonious%20worship&width=800&height=600&seq=portharcourt-live&orientation=landscape'
    },
    {
      id: 4,
      church: 'Kano Central SDA Church',
      location: 'Kano State, Northwest Region',
      conference: 'Kano-Kaduna Conference',
      badge: 'Official',
      viewers: 423,
      thumbnail: 'https://readdy.ai/api/search-image?query=church%20worship%20service%20with%20pastor%20preaching%20from%20pulpit%20congregation%20listening%20attentively%20modern%20church%20interior%20with%20natural%20lighting&width=800&height=600&seq=kano-central-live&orientation=landscape'
    }
  ];

  return (
    <div className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-8 sm:mb-12 gap-4">
          <div>
            <div className="flex items-center space-x-3 mb-3 sm:mb-4">
              <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
              <span className="text-red-500 font-semibold text-xs sm:text-sm uppercase tracking-wide">LIVE NOW</span>
              <span className="text-gray-600 text-xs sm:text-sm">• Top Churches Streaming</span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4" style={{ fontFamily: 'Noto Sans, system-ui, sans-serif' }}>
              Frequently Live – Quick Access
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl">
              Join worship services from SDA churches across Nigeria
            </p>
          </div>
          <a
            href="/live"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden lg:flex items-center space-x-2 px-6 py-3 bg-teal-600 text-white rounded-lg font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span>View All Live</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {liveStreams.map((stream) => (
            <a
              key={stream.id}
              href="https://www.youtube.com/@lavingtonsda/"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white rounded-xl overflow-hidden hover:transform hover:scale-105 transition-all duration-300 cursor-pointer shadow-lg hover:shadow-xl border border-gray-200"
            >
              <div className="relative">
                <div className="w-full h-40 sm:h-48">
                  <img
                    src={stream.thumbnail}
                    alt={stream.church}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="absolute top-3 left-3 px-3 py-1 bg-rose-500 text-white text-xs font-bold rounded-full flex items-center space-x-1 animate-pulse">
                  <span className="w-2 h-2 bg-white rounded-full"></span>
                  <span>LIVE</span>
                </div>
                <div className="absolute top-3 right-3 px-2 py-1 bg-black/70 text-white text-xs font-semibold rounded">
                  {stream.viewers.toLocaleString()}
                </div>
              </div>

              <div className="p-4">
                <h3 className="font-bold text-gray-900 mb-2 text-sm group-hover:text-teal-600 transition-colors">
                  {stream.church}
                </h3>
                <div className="space-y-1 text-xs text-gray-600">
                  <p className="flex items-center">
                    <i className="ri-map-pin-line mr-1 text-teal-600"></i>
                    {stream.location}
                  </p>
                  <p className="flex items-center">
                    <i className="ri-building-line mr-1 text-teal-600"></i>
                    {stream.conference}
                  </p>
                  <p className="flex items-center">
                    <i className="ri-live-line mr-1 text-rose-500"></i>
                    {stream.serviceType}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-6 sm:mt-8 text-center lg:hidden">
          <a
            href="/live"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 px-6 py-3 bg-teal-600 text-white rounded-lg font-medium hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base"
          >
            <span>View All Live</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </div>
  );
}
